function e(e, n, a) {
  return n in e ? Object.defineProperty(e, n, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = a, e;
}
var n = function e() {
  !function (e, n) {
    if (!(e instanceof n)) throw TypeError("Cannot call a class as a function");
  }(this, e);
};
e(n, "ripple", !1), e(n, "locale", "en");
export { n as default };